import * as React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

/**
 * Layout component that serves as the main wrapper for the application.
 */
const Layout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'grey.100' }}>
      <Outlet />
    </Box>
  )
}

export default Layout
